import React, { useContext, useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import Subnav from 'components/Subnav';
import EnterpriseContext from '../../providers/Enterprise/Enterprise.context';
import { getEnterpriseRoute } from 'utils';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';

import './RwcEnterpriseNavigation.styles.scss';

type RwcEnterpriseNavigationProps = {
  className?: string;
};

const RwcEnterpriseNavigation: React.FC<RwcEnterpriseNavigationProps> = (
  props,
) => {
  const { className } = props;

  const classes = classNames('rwc-enterprise-navigation', className);

  const { t } = useTranslation();

  const { isOfficeManager, isRegularEnterpriseMember } =
    useContext(CurrentUserContext);
  const {
    enterprise: { _id, isDemo },
  } = useContext(EnterpriseContext);

  const enterpriseRoute = getEnterpriseRoute(true, isDemo, _id);

  const routerHomeLink = useMemo(
    () => ({
      to: enterpriseRoute,
      label: t('overview'),
    }),
    [enterpriseRoute, t],
  );

  const links = useMemo(
    () => [
      {
        to: `${enterpriseRoute}/suggested-actions`,
        label: t('suggestedActionsLc'),
      },
      {
        to: `${enterpriseRoute}/configuration`,
        label: t('configuration'),
      },
      ...(isOfficeManager
        ? []
        : [
            {
              to: `${enterpriseRoute}/branding`,
              label: t('branding'),
            },
          ]),
    ],
    [enterpriseRoute, isOfficeManager, t],
  );

  // Suggested actions is the only page plain members can reach, so a subnav
  // would have nowhere to lead.
  if (isRegularEnterpriseMember) return null;

  return (
    <Subnav routerHomeLink={routerHomeLink} links={links} className={classes} />
  );
};

export default RwcEnterpriseNavigation;
